import type {z} from "zod";
import {SendCustomerOfferBody} from "@project/sdk/sales/zod";

export const sendCustomerOfferFormSchema = SendCustomerOfferBody.strict();
export type SendCustomerOfferFormPayload = z.output<typeof sendCustomerOfferFormSchema>;
export const draftSendCustomerOfferFormSchema = sendCustomerOfferFormSchema.partial();
export type DraftSendCustomerOfferFormPayload = z.output<typeof draftSendCustomerOfferFormSchema>;
